// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6df21a29","455":"33602ece"}[chunkId] + ".chunk.js";
};